import { create } from "zustand"
import { persist } from "zustand/middleware"

const useAdminModeStore = create(
  persist(
    (set) => ({
      adminMode: false,
      setAdminMode: (mode) => set({ adminMode: mode }),
    }),
    {
      name: "admin-mode-storage", // Unique name for the storage
      getStorage: () => sessionStorage, // You can use localStorage instead if you want
    }
  )
)

export default useAdminModeStore
